import styled from "styled-components";

export const StyledLandingScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 100px 30px 100px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  gap: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10% 5%;
    max-height: 100vh;
    min-height: initial;
  }
  .greeting {
    color: ${({ theme }) => theme.colors.text};

    h1 {
      font-size: 24px;
      margin: 0;
      padding: 0;
      line-height: 28px;
    }
    h4 {
      font-size: 14px;
      font-weight: 500;
      opacity: 0.7;
      margin: 0;
      padding: 0;
      line-height: 16px;
    }
  }
  .show-map {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.buttonFont};
    font-weight: 600;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 0px 12px;
    border-radius: 25px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    &:hover {
      filter: brightness(0.97);
    }
  }
  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 20px;
  }
  p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }
`;

export const StyledHorizontalCarousel = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  gap: 24px;
  /* Hide the scrollbar for WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* If you want to hide the scrollbar for Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
`;

export const SearchTriggerButton = styled.button`
  width: 100%;
  cursor: pointer;
  height: 52px;
  border-radius: 26px;
  border: 0.5px solid;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  padding: 16px;
  z-index: 9;

  p {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const ReservationReminder = styled.button`
  width: 100%;
  cursor: pointer;
  height: 52px;
  border-radius: 26px;
  border: none;
  background-color: ${({ theme }) => theme.colors.card};
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  padding: 16px;
  font-weight: 500;
  .circle {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.button};
    color: ${({ theme }) => theme.colors.buttonFont};
  }
  img {
    filter: invert(1);
  }
`;

export const MapButton = styled.button`
  position: fixed;
  bottom: 120px;
  right: 150px;
  left: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.text};
  border-radius: 24px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  gap: 12px;
  height: 50px;
  box-shadow: ${({ theme }) =>
    theme.colors.background === "#171717"
      ? theme.boxShadows.dark
      : theme.boxShadows.light};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    right: 44%;
    left: 44%;
    bottom: 30px;
  }
  img {
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }

  .map-text {
    font-weight: 600;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 8px;
  }
`;
